import React, { useContext, useState } from 'react'
import { userIdContext } from './userIdContext';
import { loginUserId } from './LoginUserIdContext';
import { FaFileImport } from "react-icons/fa";
import './DownloadAndPrint.css'
import { useMediaQuery } from 'react-responsive';


export default function ImportData() {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const { id } = useContext(loginUserId)
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleImport = async (e) => {
        e.preventDefault();

        if (!file) {
            setMessage("Please select a CSV file first.");
            return;
        }

        const formData = new FormData();
        formData.append("csv_file", file);

        try {
            const response = await fetch(`https://drclinic.fxcode.tech/php/importdata.php?loginuserid=${id}`, {
                method: "POST",
                body: formData
            });

            const text = await response.text();
            setMessage("Done");
        } catch (error) {
            setMessage("Upload failed.");
            console.error(error);
        }
    };

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1240px)'
    })
    const isSmallLap = useMediaQuery({
        query: '(min-width: 1224px) and (max-width: 1240px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })


    return (
        <form className='importForm' onSubmit={handleImport}>
            {isDesktopOrLaptop && <input className='form-control' type="file" accept=".csv" onChange={handleFileChange} />}
            {isTabletOrMobile && <input className='form-control' type="file" accept=".csv" onChange={handleFileChange} />}
            <button title='Import data to database' className='btn btn-primary' type="submit">Import CSV <FaFileImport /></button>
            <p className='label'>{message}</p>
        </form>
    );
};

